// A noite do draft.
//
// O board mostra o que o OLHEIRO diz -- faixa de teto e nota -- e nunca o
// numero real. A verdade sobre o calouro so aparece jogando, que e o ponto do
// draft: se desse para ler o potencial exato, escolher nao seria decisao.

import React, { useState } from 'react';
import { currentPick, LOTTERY_ODDS } from '../engine/draft.js';
import { draftPlayer, autoDraftPick, runDraftUntilUser, teamById, userTeam, economyOf, configOf } from '../engine/career.js';
import { POSITION_LABEL } from '../engine/players.js';
import { Ovr, Pill } from './ui.jsx';

export function DraftScreen({ state, apply, onFinish }) {
  const [aba, setAba] = useState('board');
  const draft = state.draft;
  const config = configOf(state);
  const econ = economyOf(state);
  const team = userTeam(state);

  if (!draft) return null;
  const info = currentPick(draft);
  const myTurn = !!info && info.teamId === state.clubId;
  const available = draft.prospects.filter((p) => !p.draftedBy);
  const myPicks = draft.picks.filter((p) => p.teamId === state.clubId);
  const nextMine = draft.order.indexOf(state.clubId);

  return (
    <>
      <div className="card" style={{ background: 'var(--card2)' }}>
        <div className="row spread">
          <div>
            <h3 style={{ margin: 0 }}>Draft {draft.season}</h3>
            <div className="small muted">
              {draft.rounds} rodadas · {draft.order.length * draft.rounds} escolhas
              {draft.lottery ? ' · com loteria' : ' · ordem inversa'}
            </div>
          </div>
          {draft.done
            ? <Pill on>encerrado</Pill>
            : <Pill on>{info.round}ª rodada · escolha {info.overall}</Pill>}
        </div>
      </div>

      {draft.done ? (
        <div className="card">
          <h3>Draft encerrado</h3>
          <div style={{ marginBottom: 10 }}>
            Voce escolheu {myPicks.length} calouro(s):{' '}
            {myPicks.map((p) => p.playerName).join(', ') || 'nenhum'}.
          </div>
          <button className="primary" style={{ width: '100%', padding: 13 }} onClick={onFinish}>
            Comecar a temporada {state.season + 1}
          </button>
        </div>
      ) : myTurn ? (
        <div className="onclock">
          <div style={{ fontWeight: 700, fontSize: 16 }}>Sua vez de escolher</div>
          <div className="small muted" style={{ marginTop: 3 }}>
            {info.round}ª rodada, escolha numero {info.overall} · elenco {team.roster.length}/{econ.maxRoster}
          </div>
          {team.roster.length >= econ.maxRoster && (
            <div className="small warn" style={{ marginTop: 8 }}>
              Elenco cheio. Dispense alguem no Elenco antes de usar a escolha.
            </div>
          )}
          <button
            className="ghost sm"
            style={{ marginTop: 10 }}
            onClick={() => apply((s) => autoDraftPick(s))}
          >
            levar o melhor disponivel
          </button>
        </div>
      ) : (
        <div className="card">
          <div className="row spread">
            <div>
              <div>Escolhendo agora: <b>{teamById(state, info.teamId)?.name}</b></div>
              <div className="small muted">
                Sua proxima escolha e a de numero{' '}
                {nextMine >= 0 ? nextMine + 1 + (info.round - 1) * draft.order.length : '-'}
              </div>
            </div>
            <button className="primary" onClick={() => apply((s) => runDraftUntilUser(s))}>
              avancar
            </button>
          </div>
        </div>
      )}

      <div className="row wrap" style={{ gap: 6, margin: '12px 0' }}>
        {[['board', `Calouros (${available.length})`], ['picks', `Escolhas (${draft.picks.length})`],
          ...(draft.lottery ? [['loteria', 'Loteria']] : [])].map(([id, label]) => (
            <button key={id} className={`sm ${aba === id ? 'primary' : 'ghost'}`} onClick={() => setAba(id)}>
              {label}
            </button>
        ))}
      </div>

      {aba === 'board' && (
        <div className="board">
          {available.slice(0, 40).map((p) => (
            <button
              key={p.id}
              className="prospect"
              disabled={!myTurn || team.roster.length >= econ.maxRoster}
              onClick={() => apply((s) => draftPlayer(s, p.id))}
            >
              <div className="row spread">
                <span style={{ fontWeight: 600 }}>{p.name}</span>
                <Ovr value={p.overall} />
              </div>
              <div className="small muted">
                {POSITION_LABEL[p.position]} · {p.age} anos ·{' '}
                <span className="acc">teto estimado {p.scout.floor}-{p.scout.ceiling}</span>
              </div>
            </button>
          ))}
          {!available.length && <div className="card muted">Acabaram os calouros.</div>}
          <div className="muted small" style={{ margin: '10px 0 24px' }}>
            O teto e uma ESTIMATIVA do olheiro. O numero real so aparece jogando.
          </div>
        </div>
      )}

      {aba === 'picks' && (
        <div>
          {[...draft.picks].reverse().slice(0, 60).map((pick) => (
            <div key={pick.overall} className={`pick ${pick.teamId === state.clubId ? 'me' : ''}`}>
              <div className="row spread">
                <div>
                  <span className="muted small">#{pick.overall}</span>{' '}
                  <span className="n">{pick.playerName}</span>
                  <div className="small muted">{POSITION_LABEL[pick.position]} · {pick.teamName}</div>
                </div>
                <span className="muted small">{pick.round}ª rod.</span>
              </div>
            </div>
          ))}
          {!draft.picks.length && <div className="card muted">O draft ainda nao comecou.</div>}
        </div>
      )}

      {aba === 'loteria' && draft.lottery && (
        <div className="card">
          <h3>Resultado da loteria</h3>
          <div className="small muted" style={{ marginBottom: 12 }}>
            Os {draft.lottery.pool.length} times fora dos playoffs entram no sorteio. As quatro
            primeiras escolhas saem daqui; da quinta em diante e ordem inversa.
          </div>
          <div className="scroll">
            <table>
              <thead><tr><th className="n">#</th><th className="n">time</th><th>chance</th><th>escolha</th></tr></thead>
              <tbody>
                {draft.lottery.pool.map((teamId, i) => {
                  const pos = draft.order.indexOf(teamId) + 1;
                  return (
                    <tr key={teamId} className={teamId === state.clubId ? 'me' : ''}>
                      <td className="n muted">{i + 1}</td>
                      <td className="n">{teamById(state, teamId)?.name}</td>
                      <td className="muted">{(LOTTERY_ODDS[i] ?? 0.5).toFixed(1)}%</td>
                      <td className={pos <= 4 ? 'acc' : ''} style={{ fontWeight: pos <= 4 ? 700 : 400 }}>
                        {pos}º
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div style={{ height: 24 }} />
      {void config}
    </>
  );
}
